'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryExtraContainerController = function () {
  function EnquiryExtraContainerController(authService, enums, $stateParams, lookupService, loadingService, enquiryExtraManagementService, addEditEnquiryExtraService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquiryExtraContainerController);
    this.$stateParams = $stateParams;
    this.lookupService = lookupService;
    this.loadingService = loadingService;
    this.enquiryExtraManagementService = enquiryExtraManagementService;
    this.addEditEnquiryExtraService = addEditEnquiryExtraService;

    this.enquiryExtraLookups = [];
    this.initializeEnquiryExtras();

    this.state = '';
    this.resetNotification();
  }

  (0, _createClass3.default)(EnquiryExtraContainerController, [{
    key: 'resetNotification',
    value: function resetNotification() {
      this.notification = {
        type: '',
        msg: ''
      };
    }
  }, {
    key: 'initializeEnquiryExtras',
    value: function initializeEnquiryExtras() {
      var ctrl = this;

      ctrl.loadingService.showLoading('enquiryExtraList', 'Loading Extras ...');

      ctrl.lookupService.lookupEnquiryPrices(ctrl.$stateParams.locationId).then(function (data) {
        ctrl.enquiryExtraLookups = (0, _lodash.orderBy)(data.enquiryExtras, function (o) {
          return o.name.toLowerCase();
        });
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquiryExtraList');
      });
    }
  }, {
    key: 'removeEnquiryExtra',
    value: function removeEnquiryExtra(enquiryExtra) {
      var ctrl = this;

      ctrl.loadingService.showLoading('enquiryExtraList', 'Removing Extra ...');

      ctrl.enquiryExtraManagementService.removeEnquiryExtra(ctrl.$stateParams.locationId, enquiryExtra.enquiryExtraId).finally(function () {
        ctrl.initializeEnquiryExtras();
        ctrl.loadingService.hideLoading('enquiryExtraList');
      });
    }
  }, {
    key: 'showAdd',
    value: function showAdd() {
      this.addEditEnquiryExtraService.showAdd(this.enquiryExtraLookups, this.addEnquiryExtra.bind(this));
    }
  }, {
    key: 'showEdit',
    value: function showEdit(enquiryExtra) {
      var _this = this;

      this.addEditEnquiryExtraService.showEdit(this.enquiryExtraLookups, enquiryExtra, function () {
        _this.enquiryExtraLookups = (0, _lodash.orderBy)(_this.enquiryExtraLookups, function (o) {
          return o.name.toLowerCase();
        });
      });
    }
  }, {
    key: 'addEnquiryExtra',
    value: function addEnquiryExtra(newItem) {
      this.enquiryExtraLookups.push(newItem);
      this.enquiryExtraLookups = (0, _lodash.orderBy)(this.enquiryExtraLookups, function (o) {
        return o.name.toLowerCase();
      });
    }
  }]);
  return EnquiryExtraContainerController;
}();

exports.default = EnquiryExtraContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/enquiryExtraManagement/enquiryExtraContainer/enquiryExtraContainer.controller.js